import React from 'react';

const Pagination = ({ personnelsPerPage, totalPersonnels, paginate, currentPage }) => {
  const pageNumbers = [];
  const maxPages = 10; // Nombre maximum de pages affichées

  // Calcul du nombre total de pages
  const totalPages = Math.ceil(totalPersonnels / personnelsPerPage);

  // Calcul du début et de la fin des pages affichées
  const startPage = Math.max(1, currentPage - Math.floor(maxPages / 2));
  const endPage = Math.min(totalPages, startPage + maxPages - 1);

  // Générer les numéros de page
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav>
      <ul className="pagination">
        {/* Bouton Précédent */}
        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
          <button onClick={() => paginate(currentPage - 1)} className="page-link">
            Précédent
          </button>
        </li>

        {/* Numéros de page */}
        {pageNumbers.map((number) => (
          <li key={number} className={`page-item ${number === currentPage ? 'active' : ''}`}>
            <button onClick={() => paginate(number)} className="page-link">
              {number}
            </button>
          </li>
        ))}

        {/* Bouton Suivant */}
        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
          <button onClick={() => paginate(currentPage + 1)} className="page-link">
            Suivant
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
